import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../Components/GlobalLoader/Loader";
import useEventSystem from "../../../events/useEventSystem";
import PageHeader from "../../../Layout/PageHeader";
import Tabs from "../../../Shared/Tab/Tab";
import { CardexInquiry } from "./CardexInquiry";
import { GeneralInquiry } from "./GeneralInquiry"; 
import { AvailByInvStatus } from "./AvailByInvStatus";
import { InventoryTableDetails } from "./InventoryTableDetails";
import useWarehouseStore from "../../../store/warehouse/useWarehouseStore";
import OverlayMessage from './OverlayMessage';
import { ReceivingHistory } from "./ReceivingHistory";
import { TransferHistory } from "./TransferHistory";
export default function InventoryDetails() {
  const { id } = useParams<{ id: string }>();
  const { getSelectedWarehouse } = useWarehouseStore();
  const pageName = `Item Details (${id})`;
  const [isWarehouseSelected, setIsWarehouseSelected] = useState(false);
  const [overlayMessage, setOverlayMessage] = useState("");
  const [warehouse, setWarehouse] = useState<any>(null);
  const navigation = useNavigate();
  const { emit } = useEventSystem();

  useEffect(() => {
    const subscription = getSelectedWarehouse().subscribe((warehouse) => {
      setWarehouse(warehouse);
      if (warehouse && warehouse.code!=='all') {
        emit('show_warehouse_warning', false);
        setOverlayMessage("");
        setIsWarehouseSelected(true);
      } else {
        emit('show_warehouse_warning', true);
        setIsWarehouseSelected(false);
        setOverlayMessage("Please select a Warehouse");
      }
    });

    return () => subscription.unsubscribe();
  }, [getSelectedWarehouse]);

  const handleOverlayClose = () => {
    emit('show_warehouse_warning', false);
    return navigation(`/inventory/overview`);
  }

  const tabs = [
    {
      order: 0,
      label: "General Inquiry",
      content:<GeneralInquiry warehouseId={warehouse?.id} />,
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Avail by Inv Status ",
      content: <AvailByInvStatus  warehouseId={warehouse?.id}/>,
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Cardex Inquiry",
      content: <CardexInquiry  warehouseId={warehouse?.id}/>,
      visibility: true,
      status: true,
    },
    {
      order: 3,
      label: "Receiving History",
      content: (
        <ReceivingHistory  warehouseId={warehouse?.id}/>  
      ),
      visibility: true,
      status: true,
    },
    {
      order: 4,
      label: "Transfer History",
      content: (
        <TransferHistory  warehouseId={warehouse?.id}/>  
      ),
      visibility: true,
      status: true,
    },
    // {
    //   order: 4,
    //   label: "Shipping History",
    //   content: <ShippingHistory />,
    //   visibility: true,
    //   status: true,
    // },
    {
      order: 5,
      label: "Inventory Details",
      content: (
        <InventoryTableDetails  warehouseId={warehouse?.id}/>

      ),
      visibility: true,
      status: true,
    },
    // {
    //   order: 6,
    //   label: "Inventory History",
    //   content: <InventoryHistory />,
    //   visibility: true,
    //   status: true,
    // },
  ];

  return (
    <>
      <PageHeader
        // addUrl="/inbound/returns/putaway/add"
        listUrl="/inventory/overview"
        viewType={true}
        isHistoryEnabled={true}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div>
        {!isWarehouseSelected ?
          <OverlayMessage message={overlayMessage} onClose={handleOverlayClose} /> :  warehouse ? <Tabs 
          tabs={tabs} 
          isCheckbox={true} 
          tabMeasure={true} 
          key={warehouse?.id}
        /> : <Loader/>
        }
        
      </div>

    </>
  );
}
